import { useState, useEffect } from "react";
import { supabase } from "../../supabase";
import { GEAR_CATEGORIES } from "../../constants";
import Field from "../../components/Field";
import EventCreatedModal from "./EventCreatedModal";

export default function EventForm({ event, onSave, onCancel }) {
  const [form, setForm] = useState({
    name:         event?.name         || "",
    date:         event?.date         || "",
    location:     event?.location     || "",
    startgg_link: event?.startgg_link || "",
  });
  const [requests,  setRequests]  = useState({});
  const [saving,    setSaving]    = useState(false);
  const [createdId, setCreatedId] = useState(null);

  useEffect(() => {
    if (!event?.id) return;
    supabase.from("equipment_requests").select("*").eq("event_id", event.id).then(({ data }) => {
      if (!data) return;
      const r = {};
      data.forEach(req => { r[req.item_name] = req.quantity_needed; });
      setRequests(r);
    });
  }, [event?.id]);

  async function saveRequests(eventId) {
    await supabase.from("equipment_requests").delete().eq("event_id", eventId);
    const rows = Object.entries(requests).map(([item_name, quantity_needed]) => ({ event_id: eventId, item_name, quantity_needed }));
    if (rows.length > 0) await supabase.from("equipment_requests").insert(rows);
  }

  function toggleRequest(item) {
    setRequests(prev => {
      if (prev[item] !== undefined) { const n = { ...prev }; delete n[item]; return n; }
      return { ...prev, [item]: 1 };
    });
  }

  function changeRequestQty(item, delta) {
    setRequests(prev => {
      const newQty = (prev[item] || 1) + delta;
      if (newQty <= 0) { const n = { ...prev }; delete n[item]; return n; }
      return { ...prev, [item]: newQty };
    });
  }

  async function save() {
    if (!form.name.trim()) return alert("Ponle nombre al evento.");
    setSaving(true);
    if (event?.id) {
      await supabase.from("events").update(form).eq("id", event.id);
      await saveRequests(event.id);
      setSaving(false);
      onSave();
    } else {
      const { data } = await supabase.from("events").insert(form).select("id").single();
      if (data?.id) {
        await saveRequests(data.id);
        setSaving(false);
        setCreatedId(data.id);
      } else {
        setSaving(false);
        onSave();
      }
    }
  }

  if (createdId) return <EventCreatedModal eventId={createdId} onClose={onSave} />;

  return (
    <div className="card" style={{ marginBottom: 24 }}>
      <h3 style={{ fontSize: 13, letterSpacing: 2, textTransform: "uppercase", color: "#aaa", marginBottom: 20 }}>
        {event ? "Editar evento" : "Nuevo evento"}
      </h3>
      <div style={{ display: "flex", flexDirection: "column", gap: 16 }}>
        <Field label="Nombre *">
          <input
            className="input"
            placeholder="Ej. Ranbat #12 – AnchorPoint"
            value={form.name}
            onChange={e => setForm({ ...form, name: e.target.value })}
          />
        </Field>
        <div className="form-row-2">
          <Field label="Fecha">
            <input
              className="input"
              type="date"
              value={form.date}
              onChange={e => setForm({ ...form, date: e.target.value })}
            />
          </Field>
          <Field label="Lugar">
            <input
              className="input"
              placeholder="Ej. Centro Cívico X"
              value={form.location}
              onChange={e => setForm({ ...form, location: e.target.value })}
            />
          </Field>
        </div>
        <Field label="Link de Start.gg">
          <input
            className="input"
            placeholder="https://start.gg/tournament/..."
            value={form.startgg_link}
            onChange={e => setForm({ ...form, startgg_link: e.target.value })}
          />
        </Field>

        <div>
          <div style={{ fontSize: 12, color: "#aaa", letterSpacing: 1, textTransform: "uppercase", marginBottom: 12 }}>
            Equipo prioritario <span style={{ textTransform: "none", letterSpacing: 0, fontSize: 11 }}>(opcional)</span>
          </div>
          <p style={{ fontSize: 11, color: "#888", margin: "0 0 14px" }}>
            Marca el equipo prioritario que necesita el evento. Aparecerá como alerta en la página del evento.
          </p>
          {GEAR_CATEGORIES.map(cat => (
            <div key={cat.id} style={{ marginBottom: 14 }}>
              <div style={{ fontSize: 11, letterSpacing: 2, textTransform: "uppercase", color: "#888", marginBottom: 8 }}>
                {cat.icon} {cat.label}
              </div>
              <div style={{ display: "flex", flexWrap: "wrap", gap: 6 }}>
                {cat.items.map(item => {
                  const qty        = requests[item];
                  const isSelected = qty !== undefined;
                  return (
                    <div key={item} style={{ display: "flex", alignItems: "stretch" }}>
                      <button
                        type="button"
                        onClick={() => toggleRequest(item)}
                        style={{
                          background:   isSelected ? "#cc2200" : "#141414",
                          border:       `1px solid ${isSelected ? "#cc2200" : "#2a2a2a"}`,
                          color:        isSelected ? "#fff" : "#888",
                          borderRadius: isSelected ? "4px 0 0 4px" : 4,
                          padding: "5px 10px", fontSize: 11,
                          cursor: "pointer", transition: "all 0.15s", fontFamily: "inherit",
                          fontWeight: isSelected ? 700 : 400,
                        }}
                      >
                        {item}
                      </button>
                      {isSelected && (
                        <div style={{ display: "flex", alignItems: "center", background: "#1a0800", border: "1px solid #cc2200", borderLeft: "none", borderRadius: "0 4px 4px 0" }}>
                          <button type="button" onClick={() => changeRequestQty(item, -1)} style={{ background: "none", border: "none", color: "#cc2200", cursor: "pointer", padding: "0 6px", fontSize: 15, lineHeight: 1, fontFamily: "inherit" }}>−</button>
                          <span style={{ fontSize: 11, color: "#fff", minWidth: 16, textAlign: "center", fontWeight: 700 }}>{qty}</span>
                          <button type="button" onClick={() => changeRequestQty(item, +1)} style={{ background: "none", border: "none", color: "#cc2200", cursor: "pointer", padding: "0 6px", fontSize: 15, lineHeight: 1, fontFamily: "inherit" }}>+</button>
                        </div>
                      )}
                    </div>
                  );
                })}
              </div>
            </div>
          ))}
        </div>

        <div style={{ display: "flex", gap: 10 }}>
          <button className="btn-primary" onClick={save} disabled={saving}>
            {saving ? "Guardando..." : "Guardar"}
          </button>
          <button className="btn-ghost" onClick={onCancel}>Cancelar</button>
        </div>
      </div>
    </div>
  );
}
